// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed[data-v-64b9e08e] {\n  position: fixed;\n}\n.red--circle[data-v-64b9e08e] {\n  border-radius: 50%;\n  background-color: red;\n  width: 8px;\n  height: 8px;\n}\n.item[data-v-64b9e08e] {\n  background: #f8f8f8;\n  border: 1px solid #e6e4eb;\n  box-sizing: border-box;\n  border-radius: 4px;\n}\n.z-index[data-v-64b9e08e] {\n  z-index: 9999;\n  position: fixed;\n}", ""]);
// Exports
module.exports = exports;
